<template>
  <div
    ref="timelineRef"
    class="app-timeline"
    :class="mainClasses"
  >
    <div class="app-timeline__container">
      <slot />
    </div>
    <TimelineHandler>
      <template #default="{ timeline, dates, sliderDate, handleUpdateTimeline, handleUpdateSliderDate }">
        <DSPeriodScroller
          :timeline
          :dates
          :selected="sliderDate"
          :disabled
          @update:timeline="handleUpdateTimeline"
          @update:selected="handleUpdateSliderDate"
        />
      </template>
    </TimelineHandler>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, useTemplateRef } from 'vue'

import { DSPeriodScroller } from '@ds'
import { useResizeObserver } from '@vueuse/core'
import TimelineHandler from './TimelineHandler.vue'

type Props = {
  disabled?: boolean
}

defineProps<Props>()

defineOptions({
  name: 'AppTimeline',
})

const timelineRef = useTemplateRef('timelineRef')

const isShortMode = ref(false)

useResizeObserver(timelineRef, entries => {
  isShortMode.value = entries[0]?.target
    ? entries[0]?.target?.clientWidth < 400
    : false
})

const mainClasses = computed(() => ({
  'app-timeline--short': isShortMode.value,
}))
</script>

<style>
.app-timeline {
  @apply w-full;
  @apply mt-0.5 md:-mt-2 mb-4;

  &__container {
    @apply min-h-9;
    @apply flex items-center;
    @apply gap-2 mb-2;

    .ui-preloader {
      @apply mr-auto;
    }
  }
}
</style>
